 interface VipPlan {
  id: string
  name: string
  price: string
  unit?: string
  topHint?: string
  bottomBadge?: string
  headerTone: string
  headerTextColor: string
  detailTextColor: string
  accentColor: string
  accentSoft: string
  accentStrong: string
  accentBorder: string
  benefits: string[]
}

export const planList: VipPlan[] = [
  {
    id: 'single',
    name: '单个购买',
    price: '69.9',
    unit: '/个',
    headerTone: '#FFF6E8',
    headerTextColor: '#753C05',
    detailTextColor: '#566073',
    accentColor: '#4A5568',
    accentSoft: '#F2F4F8',
    accentStrong: '#2D3748',
    accentBorder: '#D8E0ED',
    benefits: ['高清无水印源文件', '永久使用授权', '售后无忧']
  },
  {
    id: 'trial-7',
    name: '7 次体验包',
    price: '199',
    topHint: '低至¥28.4/个',
    headerTone: '#FFF6E8',
    headerTextColor: '#753C05',
    detailTextColor: '#5C667A',
    accentColor: '#3D72FF',
    accentSoft: '#EDF3FF',
    accentStrong: '#2C5CE6',
    accentBorder: '#91B4FF',
    benefits: ['7 次下载额度，永久有效，下完为止', '新模版同步可下', '在线答疑服务', '含全部免费权益']
  },
  {
    id: 'power-30',
    name: '30 次充能包',
    price: '499',
    topHint: '低至¥16.6/个',
    bottomBadge: '83%医护首选',
    headerTone: '#FFF6E8',
    headerTextColor: '#753C05',
    detailTextColor: '#5C667A',
    accentColor: '#2FBB63',
    accentSoft: '#EEFBEF',
    accentStrong: '#26A353',
    accentBorder: '#95E0A9',
    benefits: ['30 次下载额度，永久有效，下完为止', '找不到对应模板？会员需求优先上新', '赛事选题指导', '含 7 次体验包全部权益']
  },
  {
    id: 'carefree-365',
    name: '365 次无忧包',
    price: '1299',
    topHint: '低至¥3.5/个',
    bottomBadge: '科室首选',
    headerTone: '#FFF6E8',
    headerTextColor: '#753C05',
    detailTextColor: '#5C667A',
    accentColor: '#8A67FF',
    accentSoft: '#F2EDFF',
    accentStrong: '#7656E8',
    accentBorder: '#CFBEFF',
    benefits: ['365 次下载额度，永久有效，下完为止', '定制服务优先通道', 'AI 功能优先体验', '月度赛事资讯报告', '专属会员身份标识', '含 30 次充能包全部权益']
  }
]
